import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { DatePipe, CurrencyPipe } from "@angular/common";
import { merge, Observable, of as observableOf } from "rxjs";
import { Subject, Subscription } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { EntityBase } from "../../entity/EntityBase";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatTabGroup } from "@angular/material/tabs";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, MatSortHeader } from "@angular/material/sort";
import { Pair } from "../../obj/Pair";
import { SellerContract } from "../../entity/SellerContract";
import { Utility } from "../../entity/Utility";
import { SellOffer } from "../../entity/SellOffer";
import { BuyOffer } from "../../entity/BuyOffer";
import { KilowantContract } from "../../entity/KilowantContract";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { User } from "../../entity/User";
import { Company } from "../../entity/Company";
import { ConfirmationDialog } from "../incs/confirmation-dialog.component";
import { AcceptBuyOfferDialog } from "../incs/accept-buy-order-dialog.component";
import { RateClass } from "../../entity/RateClass";
import { LoadZone } from "../../entity/LoadZone";
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { MatIcon } from "@angular/material/icon";
   
@Component({
    selector: "kilowant-seller-buy-offers",
    templateUrl: "../../../html/seller/seller-buy-offers.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, CurrencyPipe, DatePipe]
})

export class SellerHomeBuyOfferComponent extends AbstractSellerComponent {
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;

    user: User = new User();
    listBuyOffersSubscription: Subscription | null;
    dialogRef: MatDialogRef<AcceptBuyOfferDialog> = null!;
    displayedColumns: string[] = ["#","UtilityName","LoadZone","RateClass","TermFrom","TermPeriod","TargetPrice","Fee","Price","ValidDate","Accounts","Action"];
    total: number = 0;
    buyOfferList: BuyOffer[] = null!;

    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        private datepipe: DatePipe,
        dialog: MatDialog
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
       this._loadBuyOffers();
    }

    _loadBuyOffers(): void {
        if (this.listBuyOffersSubscription!=null) {
           this.listBuyOffersSubscription.unsubscribe();
        }
        this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
        this.listBuyOffersSubscription = merge(this.sort.sortChange, this.paginator.page)
          .pipe(
           startWith({}),
           switchMap(() => {
            return this.generalService.getBuyOffersForSeller(this.total, this.paginator.pageIndex, this.sort.active, (this.sort.direction=="desc"));
          }),
          map(data => {
            if (data === null) {
              return [];
            }
            this.total = data.key;
            return data.value;
        }),
       )
       .subscribe(data => (this.buyOfferList = data));
    }

    markBuyOfferNotNew(buyOffer: BuyOffer): void {
        if (buyOffer.isNewRecord) {
           this.generalService.markBuyOfferViewed(buyOffer)
               .subscribe((res:any) => {
                    if (res) {
                       this._loadBuyOffers();
                    }
               },
                err => {
              });
       }
    }

    acceptBuyOffer(buyOffer: BuyOffer) {
      this.dialogRef = this.dialog.open(AcceptBuyOfferDialog, {
         disableClose: false
         ,panelClass: "card-popup"
      });
      this.dialogRef.componentInstance.confirmMessage = "Please, select the services agreement related to this buyer offer."

      this.dialogRef.afterClosed().subscribe((result: SellerContract) => {
        if (result!=null) {
          this.generalService.acceptBuyOffer(buyOffer, result)
              .subscribe((res:any) => {
                  this._loadBuyOffers();
               },
               err => {
               });
        }
        this.dialogRef = null!;
       });       
    }

   ngOnDestroy(){
        if (this.listBuyOffersSubscription!=null) {
           this.listBuyOffersSubscription.unsubscribe();
        }
   }

}